import {VisualArtifactRef} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualArtifactRef';
import {LoggingConfig} from '@mintdata/mint-kit/api/log/mk';

//this is resolved by webpack's DefinePlugin during bundling
declare const MINTDATA_CONFIG:any;
const envConfig = MINTDATA_CONFIG;

export type MintdataBundle = {
    organization:string;
    name:string;
    version:string;
};

export type Features = {
    [key:string]:any,
}

export type FeaturesRegistry = {
    [key:string]:any,
    perOrg:{
        [orgName:string]:Features
    },
}

export class ConfigUtil
{
    public static isProd():boolean
    {
        return envConfig && envConfig.env === 'prod';
    }

    public static useDashOrgInPublishedAppUrls():string
    {
        return envConfig && envConfig.useDashOrgInPublishedAppUrls;
    }

    public static apiHostname():string
    {
        return envConfig && envConfig.apiHostname;
    }

    public static apiSecure():boolean
    {
        return envConfig && envConfig.apiSecure;
    }

    public static hippoHostname():string
    {
        return envConfig && envConfig.hippoHostname;
    }

    public static hippoPort():number
    {
        return envConfig && envConfig.hippoPort;
    }

    public static isHippoSecured():boolean
    {
        return envConfig && !!envConfig.hippoSecured;
    }

    public static isLogRocketEnabled():boolean
    {
        if( envConfig && envConfig.logRocket )
            return envConfig.logRocket.enabled;

        return false;
    }

    public static logRocketAccessKey():string
    {
        if( envConfig && envConfig.logRocket )
            return envConfig.logRocket.accessKey;

        return '';
    }

    public static cdnMdBaseUrl():string
    {
        return envConfig && envConfig.cdnMdBaseUrl;
    }

    public static cdnNpmBaseUrl():string
    {
        return envConfig && envConfig.cdnNpmBaseUrl;
    }

    public static cdnIconsFileUrl():string
    {
        return envConfig && envConfig.cdnIconsFileUrl;
    }

    public static cdnIconsDirUrl():string
    {
        return envConfig && envConfig.cdnIconsDirUrl;
    }

    public static cdnIllustrations1FileUrl():string
    {
        return envConfig && envConfig.cdnIllustrations1FileUrl;
    }

    public static cdnIllustrations1DirUrl():string
    {
        return envConfig && envConfig.cdnIllustrations1DirUrl;
    }

    public static cdnIllustrations2FileUrl():string
    {
        return envConfig && envConfig.cdnIllustrations2FileUrl;
    }

    public static cdnIllustrations2DirUrl():string
    {
        return envConfig && envConfig.cdnIllustrations2DirUrl;
    }

    public static cdnEmojisFileUrl():string
    {
        return envConfig && envConfig.cdnEmojisFileUrl;
    }

    public static cdnUrl():string
    {
        return envConfig && envConfig.cdnUrl;
    }

    public static isAppSecure():boolean
    {
        return envConfig && envConfig.appSecure;
    }

    public static isSessionValidationEnabled():boolean
    {
        return envConfig && envConfig.isSessionValidationEnabled;
    }

    public static isPublishZipEnabled():string
    {
        const features:FeaturesRegistry = ConfigUtil.featuresRegistry();
        return features.isPublishZipEnabled;
    }

    public static isGoogleSignInButtonEnabled():boolean
    {
        const features:FeaturesRegistry = ConfigUtil.featuresRegistry();
        return features.isGoogleSignInButtonEnabled;
    }

    public static isVersionHistoryMenuEnabled():boolean
    {
        const features:FeaturesRegistry = ConfigUtil.featuresRegistry();
        return features.isVersionHistoryMenuEnabled;
    }

    public static latestVisualArtifacts():Array<VisualArtifactRef>
    {
        if( envConfig && envConfig.latestVisualArtifacts )
        {
            return envConfig.latestVisualArtifacts
                .map(ref => new VisualArtifactRef(ref.organization, ref.name, ref.version));
        }
        return [];
    }

    // TODO: this shouldn't go from configuration, but rather from db, i.e. use API.features.get(...)
    public static featuresRegistry():FeaturesRegistry
    {
        return envConfig && envConfig.features || {};
    }

    public static loggingConfig():LoggingConfig
    {
        return envConfig && envConfig.logging || {};
    }

    public static intercomAppId():string
    {
        return envConfig && envConfig.INTERCOM_APP_ID;
    }

    public static gaMeasurementId():string
    {
        return envConfig && envConfig.GA_MEASUREMENT_ID;
    }

    public static mixpanelProjectToken():string
    {
        return envConfig && envConfig.MIXPANEL_PROJECT_TOKEN;
    }

    public static publishedAppsHost():string
    {
        return envConfig && envConfig.publishedAppsHost;
    }

    public static publishedAppsSecured():string
    {
        return envConfig && envConfig.publishedAppsSecured;
    }

    public static useAppLogin():boolean
    {
        return envConfig && envConfig.useAppLogin;
    }

    public static useIntercom():boolean
    {
        return envConfig && envConfig.useIntercom;
    }

    public static useAnalytics():boolean
    {
        return envConfig && envConfig.useAnalytics;
    }
}
